import { combineReducers } from 'redux';
import suppliers from './SupplierReducer';
import admins from './AdminReducer';
import customers from './CustomerReducer';
import auths from './AuthReducer';
import trackings from './TrackingReducer';
import products from './productReducer';

const rootReducer = combineReducers({
    trackings,
    suppliers,
    customers,
    admins,
    products,
    auths
});

export default rootReducer;
